export default __webpack_public_path__ + "static/media/logo-compracerta@3x.742d9afb.svg";